// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nincada: PokeData = {
  "id": 290,
  "name": "nincada",
  "height": 5,
  "weight": 55,
  "base_experience": 53,
  "types": [
    PokeType.BUG,
    PokeType.GROUND
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "absorb",
    "dig",
    "harden",
    "bide",
    "leech-life",
    "fury-swipes",
    "mind-reader",
    "mud-slap",
    "false-swipe",
    "metal-claw"
  ],
  "moves": [
    "scratch",
    "mud-slap",
    "metal-claw",
    "bonemerang",
    "leech-steal",
    "lunge",
    "pin-missile",
    "mud-shot",
    "infest",
    "mud-bomb",
    "heal-order",
    "sticky-web",
    "rototiller"
  ],
  "evolution_chain": {
    "id": 144,
    "item": null,
    "species": [
      {
        "name": "nincada",
        "order": 316,
        "types": [
          PokeType.BUG,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninjask",
        "order": 317,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 290,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "shedinja",
        "order": 318,
        "types": [
          PokeType.BUG,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 290,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.SHED
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45.5,
    "speed": 40,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
